export default __webpack_public_path__ + "static/media/Flight.72f632c8.svg";